// extracted by mini-css-extract-plugin
export default {"search":"SearchBar_search__JlJhV","searchBar":"SearchBar_searchBar__gWDiC","searchTerm":"SearchBar_searchTerm__8kJVz","searchWrapper":"SearchBar_searchWrapper__JSBBf"};